import { TableStore } from "src/components/tables/TableStore";
import { singleLoader } from "src/components/tables/singleLoader";
import { ZUid } from "src/types/zUid";
import { ZMc2 } from "../../../Mc2Types";
import { loadMc2Summary } from "../../../apiMc2";

export const createMc2CopyFromStore = (modelEntityId: ZUid) =>
  new TableStore<ZMc2, {}>({
    rowKey: "id",
    fnLoad: singleLoader(
      () => loadMc2Summary(modelEntityId),
      () => true,
    ),
    selectionSettings: {
      selectionType: "checkbox",
    },
  });
